import EXIF from "exif-js"
import DeviceService from 'Services/device';

export default {
	name: 'Phone',
	props: {
		device: {
			value: Object
		},
		grid: {
			value: Object
		},
		isDeviceSelected: {
			type: Function
		},
		redirectToDevice: {
			type: Function
		},
	},
	beforeCreate() {
		this.$options.filters.capitalize = this.$options.filters.capitalize.bind(this);
		this.$options.filters.formatDate = this.$options.filters.formatDate.bind(this);
	},
	mounted() {
		const image = this.$refs.image;
		image.style.width = this.defaultImageWidth + 'px';
		image.style.height = this.defaultImageHeight + 'px';
		window.addEventListener('resize', this.onImageLoaded);
	},
	watch: {
		online(value) {
			if (!this.isScreenMonitoringEnabled) {
				return;
			}
			if (!value) {
				this.clearRefreshImageTimeout(this.refreshImageTimeout);
			} else if (this.refreshImageTimeout === null && this.isScreenMonitoringTurnedOn) {
				this.setRefreshImageTimeout(this.getElapsedTime(this.lastSeen));
			}
		},
		isScreenMonitoringTurnedOn(value) {
			if (!this.isScreenMonitoringEnabled) {
				return;
			}
			if (!value) {
				this.clearRefreshImageTimeout(this.refreshImageTimeout);
			} else if (this.refreshImageTimeout === null && this.online) {
				this.setRefreshImageTimeout(this.getElapsedTime(this.lastSeen));
			}
		},
	},
	data() {
		return {
			isScreenMonitoringEnabled: process.env.SCREEN_MONITORING === 'true',
			refreshTime: 930000, // 15.5 mins
			defaultImageWidth: 279,
			defaultImageHeight: 585,
			lastSeen: '',
			lastSeenTooltip: '',
			dateSplitter: /[\s:]/,
			startDate: new Date(2020, 2, 12, 12, 0, 0),
			refreshImageTimeout: null,
			showTooltip: false
		};
	},
	computed: {
		online() {
			return this.device.Online;
		},
		isScreenMonitoringTurnedOn() {
			return this.$store.state.user.isScreenMonitoringEnabled;
		}
	},
	methods: {
		arrayBufferToBase64( buffer ) {
		    var binary = '';
		    var bytes = new Uint8Array( buffer );
		    var len = bytes.byteLength;
		    for (var i = 0; i < len; i++) {
		        binary += String.fromCharCode( bytes[ i ] );
		    }
		    return window.btoa( binary );
		},
		onImageLoaded() {
			const vue = this;
			const image = this.$refs.image;

			if (image.naturalHeight !== 0) {
				if (this.lastSeen === null) {
					this.lastSeen = '';
				}
				image.style.width = '';
				image.style.height = '';
				image.exifdata = undefined;
				EXIF.getData(image, function() {
					if (this.exifdata.DateTime !== undefined) {
						vue.lastSeen = this.exifdata.DateTime;
						vue.showTooltip = true;
						vue.setLastSeenTooltip();
						vue.setRefreshImageTimeout(vue.getElapsedTime(vue.lastSeen));
					} else {
						vue.showTooltip = false;
						vue.setRefreshImageTimeout(0);
					}
				});
			}
			this.setImagePadding();
		},
		onImageError() {
			this.lastSeen = null;
			const image = this.$refs.image;
			image.style.width = this.defaultImageWidth + 'px';
			image.style.height = this.defaultImageHeight + 'px';
			this.showTooltip = false;
			this.setRefreshImageTimeout(this.refreshTime);
			this.setImagePadding();
		},
		setImagePadding() {
			const image = this.$refs.image;
			const padding = image.height * 0.08;
			if (padding > 0) {
				image.style.paddingTop = padding + 'px';
				image.style.paddingBottom = padding + 'px';
			}
		},
		capitalize(string) {
			return (string || '').replace(/\b\w/g, l => l.toUpperCase());
		},
		formatNumber(number) {
			return ("0" + number).slice(-2);
		},
		refreshImage() {
			DeviceService.getPreview(this.device.PublicID)
			.then(response => {
				this.$refs.image.src = `data:image/jpeg;base64,${this.arrayBufferToBase64(response.data)}`
			})
			.catch(error => {
				const image = this.$refs.image;
				image.style.width = this.defaultImageWidth + 'px';
				image.style.height = this.defaultImageHeight + 'px';
			});
			this.clearRefreshImageTimeout();
		},
		setRefreshImageTimeout(elapsedTime) {
			if (!this.device.Online || !this.isScreenMonitoringEnabled || !this.isScreenMonitoringTurnedOn) {
				return;
			}
			this.clearRefreshImageTimeout();
			let timeout = 300000;
			if (this.refreshTime - elapsedTime > 0) {
				timeout = this.refreshTime - elapsedTime;
			}
			this.refreshImageInterval = setTimeout(this.refreshImage, timeout);
		},
		clearRefreshImageTimeout() {
			clearTimeout(this.refreshImageTimeout);
			this.refreshImageTimeout = null;
		},
		getElapsedTime(date) {
			const now = new Date(Date.now());
			let lastSeen;
			if (date === '') {
				lastSeen = this.startDate;
			} else {
				lastSeen = this.getDateFromExif(date);
			}

			return now - lastSeen;
		},
		getDateFromExif(date) {
			let sDate = date.split(this.dateSplitter);
			if (sDate.length != 6) {
				this.showTooltip = false;
				return this.startDate;
			}

			sDate[1] = --sDate[1];
			return new Date(Date.UTC(...sDate));
		},
		setLastSeenTooltip() {
			let lastSeenDate = this.getDateFromExif(this.lastSeen);
			this.lastSeenTooltip = lastSeenDate.toLocaleDateString() + ' ' + lastSeenDate.toLocaleTimeString();
		}
	},
	filters: {
		status(status) {
			return status ? `Online` : `Offline`;
		},
		capitalize(string) {
			return this.capitalize(string);
		},
		truncate(text, length, suffix) {
			if (text.length > length) {
				return text.substring(0, length) + suffix;
			} else {
				return text;
			}
		},
		formatDate(date) {
			if (date === null) {
				return 'have not seen yet';
			}
			const elapsed = this.getElapsedTime(date);

			const msPerMinute = 60 * 1000;
    		const msPerHour = msPerMinute * 60;
    		const msPerDay = msPerHour * 24;
    		const msPerMonth = msPerDay * 30;
    		const msPerYear = msPerDay * 365;

			if (elapsed < msPerMinute) {
				return 'a few seconds ago';
    		}

			if (elapsed < msPerHour) {
				return  Math.ceil(Math.round(elapsed/msPerMinute)/5)*5 + ' minutes ago';
			}
			else if (elapsed < msPerDay ) {
				return Math.round(elapsed/msPerHour ) + ' hours ago';
			}
			else if (elapsed < msPerMonth) {
				return Math.round(elapsed/msPerDay) + ' days ago';
			}
			else if (elapsed < msPerYear) {
				return Math.round(elapsed/msPerMonth) + ' months ago';
			}
			else {
				return Math.round(elapsed/msPerYear ) + ' years ago';
			}
		},
	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.onImageLoaded);
		this.clearRefreshImageTimeout(this.refreshImageTimeout);
	}
};


// WEBPACK FOOTER //
// ./app/components/phone/script.js